/* eslint-disable no-undef */
import { toast } from "react-toastify";
import { BASE_URL } from "./connectionUrl";

export const getExportItem = async (
  token,
  type = null,
  endDate = null,
  startDate = null,
) => {
  const endpoint =
    type === null
      ? `/api/v1/admin/reports/export_invoice_items_report?start_date=${startDate}&end_date=${endDate}&type=${type}`
      : `/api/v1/admin/reports/export_invoice_items_report?start_date=${startDate}&end_date=${endDate}&type=${type}`;
  try {
    const response = await fetch(`${BASE_URL}${endpoint}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Token ${token}`,
      },
    });

    const data = await response.json();
    if (response.ok) {
      return data;
    } else {
      toast.error(data?.status?.message || "something went wrong");
    }
  } catch (error) {
    toast.error(error.message || "something went wrong");
  }
};
